module.exports = __webpack_public_path__ + "img/emoji_84.3c6ce394.png";